import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { auth_server } from '../../assets/conf_urls.json';
import { Observable, Subscription, of, Subject, BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private router: Router) { }
  //used for the http interceptor to better capture the user details.
  // user=new BehaviorSubject<SiteUser>(null);

  check_auth(token: string): Observable<boolean> {
    let result = new Subject<boolean>();
    const headers = { 'Authorization': 'Bearer ' + token, responseType: 'text' };
    this.http.post(auth_server.verify, "", { headers }).subscribe(res => {
      if (res) {
        result.next(true);
        return true
      } else {
        this.router.navigate(['/login']);
        return false
      }
    }, (error) => {
      result.next(false)
      this.router.navigate(['/login']);
      return false
    });
    return result.asObservable()
  }
}
